import { ColumnDef, SummaryCardDefinition } from '../interfaces/reports.interface';

export const EMPTY_VALUE = '-';
export const DEFAULT_SEVERITY = 'info';

export const CERTIFICATE_LOGO_SVG = `
<svg width="154" height="40" viewBox="0 0 154 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.29101 7.84786H6.04251V20.8469L12.9482 10.1418C13.8654 8.72174 15.43 7.84786 17.1025 7.84786H22.3896L13.7575 20.6284L22.7673 39.1438H15.6997L11.5995 28.1656C10.3046 25.9809 9.60327 25.6532 8.30845 25.9263C7.06758 26.1448 5.98856 27.2371 5.98856 28.2749V36.7952C5.98856 38.1061 5.17929 39.1984 3.88447 39.1984H0V11.1795C0 9.32253 1.51063 7.84786 3.29101 7.84786Z" fill="#204FBB"/>
  <path d="M51.0376 39.6353C43.8082 39.4169 40.1935 35.1567 40.1935 26.8548C40.1935 18.6075 43.8621 14.4566 51.1455 14.4566C58.7526 14.4566 62.3133 19.1537 61.8817 28.6572H46.3978C46.6136 32.3712 48.2322 34.2282 51.1455 34.2282C52.5482 34.2282 53.843 33.6274 55.03 32.4804C55.5695 31.8796 56.2708 31.6065 57.0801 31.6065H61.5041C60.2093 36.7952 56.9183 39.6353 51.0376 39.6353ZM46.4518 24.3424H55.4616C55.0839 21.12 53.6272 19.4814 51.0376 19.4814C48.448 19.4814 46.9373 21.12 46.4518 24.3424Z" fill="#204FBB"/>
  <path d="M87.1847 8.88559V28.6572C87.1847 35.9213 83.4082 39.5807 75.9629 39.5261C68.5177 39.3623 64.849 35.3206 64.849 27.2371C64.849 18.9899 68.0322 14.7843 74.3984 14.5658C77.3657 14.5658 79.6856 15.822 81.2501 18.3345V5.77239H84.2174C85.836 5.77239 87.1847 7.19244 87.1847 8.88559ZM71.0534 26.964C70.9995 31.8796 72.618 34.3374 76.0708 34.3374C79.5237 34.3374 81.2501 31.8796 81.2501 26.964C81.0883 22.2669 79.4158 19.973 76.1787 19.973C72.9417 19.973 71.2153 22.2669 71.0534 26.964Z" fill="#204FBB"/>
  <path d="M93.9826 14.1289C95.9248 14.1289 96.8959 15.112 96.8959 17.0782V39.1438H90.9074V14.1289H93.9826Z" fill="#204FBB"/>
  <path d="M37.3341 14.8935C34.7984 14.8935 32.6403 15.2759 30.9139 16.0951C30.5362 15.0574 29.6191 14.5658 28.2163 14.5658H25.0332V39.1438H31.1297V26.4179C31.1837 22.977 32.8561 21.2292 36.1471 21.2292H38.1973V14.8935H37.3341Z" fill="#204FBB"/>
  <path d="M96.8959 8.83097C96.8959 10.5241 95.5471 11.8896 93.8747 11.8896C92.2022 11.8896 90.8534 10.5241 90.8534 8.83097C90.8534 7.13783 92.2022 5.77239 93.8747 5.77239C95.5471 5.77239 96.8959 7.13783 96.8959 8.83097Z" fill="#204FBB"/>
  <path d="M111.409 38.9799V24.5609L98.9461 0.365234H107.578L115.023 17.0236L120.85 2.71379C121.498 1.1845 122.577 0.365234 124.087 0.365234H129.86L118.584 24.5609V38.9799H111.409Z" fill="#DC1A4C"/>
  <path d="M147.34 19.536C149.12 18.2798 150.361 17.5152 150.739 17.2421C152.304 16.3136 151.44 15.3305 151.44 15.3305C151.278 15.3305 151.117 15.3305 150.955 15.3305H150.901C150.847 15.3305 150.793 15.3305 150.685 15.3305C150.631 15.3305 150.631 15.3305 150.577 15.3305C150.523 15.3305 150.469 15.3305 150.415 15.3305C150.361 15.3305 150.361 15.3305 150.307 15.3305C150.253 15.3305 150.199 15.3305 150.145 15.3305C150.092 15.3305 150.092 15.3305 150.038 15.3305C149.984 15.3305 149.93 15.3305 149.93 15.3305C149.876 15.3305 149.876 15.3305 149.822 15.3305C149.768 15.3305 149.714 15.3305 149.714 15.3305C149.66 15.3305 149.66 15.3305 149.606 15.3305C149.552 15.3305 149.498 15.3305 149.444 15.3305H149.39C149.336 15.3305 149.228 15.3851 149.174 15.3851C149.12 15.3851 149.066 15.3851 149.013 15.4397H148.959C148.905 15.4397 148.905 15.4397 148.851 15.4397H148.797C148.743 15.4397 148.743 15.4397 148.743 15.4397H148.635C148.635 15.4397 148.635 15.4397 148.581 15.4397H148.527C148.527 15.4397 148.527 15.4397 148.473 15.4397H148.419C147.987 15.5489 147.502 15.6582 147.07 15.7674C146.908 15.822 146.747 15.8767 146.585 15.8767C144.211 16.5321 141.999 17.4059 139.949 18.3344C139.787 18.4437 139.571 18.4983 139.409 18.6075C139.193 18.7168 138.978 18.826 138.762 18.9352C138.6 19.0445 138.438 19.0991 138.222 19.2083C138.007 19.3176 137.791 19.4814 137.521 19.5907C135.741 20.6284 134.122 21.7207 132.665 22.8677L133.421 20.3007L137.035 7.73862L139.679 16.8052C141.567 15.8767 143.563 15.112 145.775 14.4566L141.19 0.365234H135.525C133.798 0.365234 132.665 1.23912 132.18 2.93227L120.688 38.9799H128.241C130.292 33.7366 136.334 28.0018 141.675 23.7962L143.833 31.115L146.099 39.0346H153.544L147.34 19.536Z" fill="#DC1A4C"/>
</svg>
`;

export const SUMMARY_CARD_DEFINITIONS: SummaryCardDefinition[] = [
  {
    statusKey: 'pending_app_download',
    label: 'PDTE. DESCARGA APP',
    sublabel: 'App no descargada',
    colorClass: 'reports__cardsItem--purple',
    arrowIcon: 'pi pi-arrow-right'
  },
  {
    statusKey: 'pending_enrollment',
    label: 'PDTE. ENROLAMIENTO',
    sublabel: 'App OK, falta enrolar el equipo',
    colorClass: 'reports__cardsItem--yellow',
    arrowIcon: 'pi pi-arrow-right'
  },
  {
    statusKey: 'pending_contract_signature',
    label: 'PDTE. FIRMA CONTRATO',
    sublabel: 'Enrolado, falta firma',
    colorClass: 'reports__cardsItem--orange',
    arrowIcon: 'pi pi-arrow-right'
  },
  {
    statusKey: 'completed',
    label: 'COMPLETADO',
    sublabel: '100% legalizado',
    colorClass: 'reports__cardsItem--green',
    arrowIcon: 'pi pi-arrow-right'
  },
  {
    statusKey: 'total',
    label: 'TOTAL PERIODO',
    sublabel: 'Monto total del periodo',
    colorClass: 'reports__cardsItem--blue',
    arrowIcon: 'pi pi-arrow-right'
  }
];

export const AVAILABLE_COLUMNS: ColumnDef[] = [
  { field: 'contrato', header: 'Contrato', locked: true },
  { field: 'identidad', header: 'Identidad', locked: true },
  { field: 'cliente', header: 'Cliente', locked: true },
  { field: 'producto', header: 'Producto financiado' },
  { field: 'imei', header: 'IMEI' },
  { field: 'estado', header: 'Estado del crédito' },
  { field: 'pagoAliado', header: 'Pago aliado' },
  { field: 'valorTotal', header: 'Valor total' },
  { field: 'financiado', header: 'Financiado' },
  { field: 'anticipo', header: 'Anticipo' },
  { field: 'fechaSolicitud', header: 'Fecha solicitud' },
  { field: 'ultimaActualizacion', header: 'Ultima act.' }
];

export const LEGALIZATION_LABELS: Record<string, string> = {
  pending_app_download: 'Pdt. Descarga App',
  pending_enrollment: 'Pdt. Enrolamiento',
  pending_contract_signature: 'Pdt. Firma Contrato',
  completed: 'Finalizado',
  finalizado: 'Finalizado'
};

export const LEGALIZATION_SEVERITIES: Record<string, string> = {
  pending_app_download: 'pending-download',
  pending_enrollment: 'pending-enrollment',
  pending_contract_signature: 'pending-sign',
  completed: 'success',
  finalizado: 'success'
};

export const ALLY_PAYMENT_LABELS: Record<string, string> = {
  PENDING: 'Pendiente',
  APPLIES: 'Aplica pago',
  PAID: 'Pagado',
  NOT_APPLIES: 'No aplica',
  valido: 'Aplica pago',
  valid: 'Aplica pago',
  no_valido: 'No aplica',
  invalid: 'No aplica',
  Pendiente: 'Pendiente',
  'Aplica pago': 'Aplica pago',
  Pagado: 'Pagado',
  'No aplica': 'No aplica'
};

export const ALLY_PAYMENT_SEVERITIES: Record<string, string> = {
  PENDING: 'warning',
  APPLIES: 'success',
  PAID: 'success',
  NOT_APPLIES: 'secondary',
  valido: 'success',
  valid: 'success',
  no_valido: 'secondary',
  invalid: 'secondary',
  Pendiente: 'warning',
  'Aplica pago': 'success',
  Pagado: 'success',
  'No aplica': 'secondary'
};

export const ALLY_PAYMENT_TITLES: Record<string, string> = {
  PENDING: 'PAGO PENDIENTE DE HABILITACIÓN',
  APPLIES: 'APLICA PAGO AL ALIADO',
  PAID: 'PAGO AL ALIADO REALIZADO',
  NOT_APPLIES: 'NO APLICA PAGO AL ALIADO',
  valido: 'APLICA PAGO AL ALIADO',
  valid: 'APLICA PAGO AL ALIADO',
  'APLICA PAGO': 'APLICA PAGO AL ALIADO',
  no_valido: 'NO APLICA PAGO AL ALIADO',
  invalid: 'NO APLICA PAGO AL ALIADO',
  Pendiente: 'PAGO PENDIENTE DE HABILITACIÓN',
  'Aplica pago': 'APLICA PAGO AL ALIADO',
  Pagado: 'PAGO AL ALIADO REALIZADO',
  'No aplica': 'NO APLICA PAGO AL ALIADO'
};

export const ALLY_PAYMENT_MESSAGES: Record<string, string> = {
  PENDING: 'El crédito aún no completó el proceso de legalización. El pago al aliado se habilitará al alcanzar estado “Completado”.',
  APPLIES: 'El crédito está completamente legalizado. KrediYA realizará el pago correspondiente al comercio.',
  PAID: 'El pago correspondiente al comercio ya fue realizado.',
  NOT_APPLIES: 'Este crédito no aplica para pago al aliado.',
  valido: 'El crédito está completamente legalizado. KrediYA realizará el pago correspondiente al comercio.',
  valid: 'El crédito está completamente legalizado. KrediYA realizará el pago correspondiente al comercio.',
  'APLICA PAGO': 'El crédito está completamente legalizado. KrediYA realizará el pago correspondiente al comercio.',
  no_valido: 'Este crédito no aplica para pago al aliado.',
  invalid: 'Este crédito no aplica para pago al aliado.',
  Pendiente: 'El crédito aún no completó el proceso de legalización. El pago al aliado se habilitará al alcanzar estado “Completado”.',
  'Aplica pago': 'El crédito está completamente legalizado. KrediYA realizará el pago correspondiente al comercio.',
  Pagado: 'El pago correspondiente al comercio ya fue realizado.',
  'No aplica': 'Este crédito no aplica para pago al aliado.'
};
